<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
    <h1 class="sr-only">Answer Engine Optimization (AEO) Services — Get Cited in ChatGPT, Perplexity, and Google AI Overviews</h1>
    <app-hero-section height="520px" paddingTop="300px" opacity="0.8"
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" [titleHtml]="heroTitleHtml"
        text="service"></app-hero-section>
    <div class="flex flex-col items-center text-center px-4 mt-[60px]">
        <app-button buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
    </div>
    <app-lead-section [section]="introA"></app-lead-section>
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="chatgptSection" layout="center" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="entitySection" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-2.avif">
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="citationSection" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-steps-section [section]="schemaSection"></app-steps-section>
    <hr appReveal class="section-divider" />
    <app-icon-section [section]="googleAiSection" iconSide="left"
        icon="images/aeo-marketing-service/platform/google-ai.png"></app-icon-section>
</app-background>
<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <hr appReveal class="section-divider" />
    <app-dev-services [section]="geoSection" [cards]="geoCards"></app-dev-services>
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="reportingSection" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-lead-section [section]="whyChooseSection" layout="center"></app-lead-section>
    <div class="h-[60px]"></div>
    <app-connect></app-connect>
</app-background>
